import { render, staticRenderFns } from "./StrikeOptions.vue?vue&type=template&id=2ec6f126&scoped=true"
import script from "./StrikeOptions.vue?vue&type=script&lang=ts&setup=true"
export * from "./StrikeOptions.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./StrikeOptions.vue?vue&type=style&index=0&id=2ec6f126&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec6f126",
  null
  
)

export default component.exports